import type { WidgetApi, WidgetSettings } from "@/shared/config";

import {
    DEFAULT_WIDGET_SETTINGS,
    isLocale,
    LOCALES,
    WIDGET_API_KEYS,
    WIDGET_MODES,
} from "@/shared/config";
import { logger } from "@/shared/lib";

/** Partners call mount() from plain JS, so the options are validated at runtime */
export function resolveSettings(raw: unknown): WidgetSettings | null {
    const settings = { ...DEFAULT_WIDGET_SETTINGS, ...(raw as Partial<WidgetSettings>) };

    if (typeof settings.domain !== "string" || !settings.domain) {
        logger.error("settings.domain is not defined");
        return null;
    }

    if (!WIDGET_MODES.includes(settings.mode)) {
        logger.error(`settings.mode is not correct. Available modes: ${WIDGET_MODES.join(", ")}`);
        return null;
    }

    if (!isLocale(settings.locale)) {
        logger.warn(
            `settings.locale "${settings.locale}" is not supported, "${DEFAULT_WIDGET_SETTINGS.locale}" is used. Available locales: ${LOCALES.join(", ")}`,
        );
        settings.locale = DEFAULT_WIDGET_SETTINGS.locale;
    }

    return { ...settings, domain: settings.domain };
}

export function resolveApi(raw: unknown): WidgetApi {
    const api: Record<string, unknown> = {};
    const source = (raw ?? {}) as Record<string, unknown>;

    for (const key of WIDGET_API_KEYS) {
        if (source[key] === undefined || source[key] === null) continue;

        if (typeof source[key] !== "function") {
            logger.warn(`api.${key} must be a function, ignored`);
            continue;
        }

        api[key] = source[key];
    }

    return api as WidgetApi;
}
